export const GmtOffsetTypes = {
    Account: 1,
    Browser: 2,
    DashboardTimezone: 3
}
